import { ServiceName, serviceName } from './translation';

export const LANGUAGE_STORAGE_KEY = 'app.lng';

export type Languages = 'en' | 'ko' | 'th' | 'zh' | 'ja';
export type LanguageCode = keyof typeof baseLanguageLabels;
export type LanguageOption = { code: LanguageCode; label: string };

export const baseLanguageLabels = {
  // key: 'CodeKey',
  ko: '한국어',
  en: 'English',
  th: 'ไทย',
  zh: '繁體中文',
  ja: '日本語',
} as const satisfies Record<string, string>;

export const baseLanguageOptions: readonly LanguageOption[] = [
  { code: 'en', label: baseLanguageLabels.en },
  { code: 'ko', label: baseLanguageLabels.ko },
  { code: 'ja', label: baseLanguageLabels.ja },
  { code: 'zh', label: baseLanguageLabels.zh },
  { code: 'th', label: baseLanguageLabels.th },
] as const;

// 로그인할때 필요한 국가 리스트 (API 호출 X) heard by 박창규/@IOS at 08202025
const supportedLanguageOptionsByService: Record<ServiceName, typeof baseLanguageOptions> = {
  bubblechat: baseLanguageOptions.filter((lng) => lng.code !== 'en' && lng.code !== 'zh'),
  tingle: baseLanguageOptions.filter((lng) => lng.code !== 'en'),
};

const uiLanguageCodesByService: Record<ServiceName, typeof baseLanguageOptions> = {
  bubblechat: baseLanguageOptions.filter((lng) => lng.code !== 'zh'),
  tingle: baseLanguageOptions,
};

export const uiLanguageCodeValuesByService: Record<ServiceName, LanguageCode[]> = {
  bubblechat: uiLanguageCodesByService.bubblechat.map((lng) => lng.code),
  tingle: uiLanguageCodesByService.tingle.map((lng) => lng.code),
};

export const supportedLanguageCodes = supportedLanguageOptionsByService[serviceName];
export const uiLanguageCodes = uiLanguageCodesByService[serviceName];
export const uiLanguageCodeValues = uiLanguageCodeValuesByService[serviceName];

// HTTP Accept-Language 헤더 전송용 BCP47 매핑
// (서버 정식 지원: ko-KR, ja-JP, zh-Hant-TW, th-TH)
export const languageCodeToBCP47: Record<LanguageCode, string> = {
  ko: 'ko-KR',
  en: 'en-US',
  ja: 'ja-JP',
  zh: 'zh-Hant-TW',
  th: 'th-TH',
};

// HTTP Accept-Language 헤더 전송용 BCP47 매핑 (국가 코드 → BCP47)
// (서버 정식 지원: ko-KR, ja-JP, zh-Hant-TW, th-TH)
export type CountryCode = 'KR' | 'US' | 'JP' | 'TW' | 'TH';

export const countryCodeToBCP47: Record<CountryCode, string> = {
  KR: 'ko-KR',
  US: 'en-US',
  JP: 'ja-JP',
  TW: 'zh-Hant-TW',
  TH: 'th-TH',
};
